import { render, staticRenderFns } from "./CampanhaView.vue?vue&type=template&id=10a04734"
import script from "./CampanhaView.vue?vue&type=script&lang=js"
export * from "./CampanhaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports